import './style.scss';
import { addBeneficiary, getBeneficiary } from '../../API/apiService';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function AddBeneficiaryModal({ info, setOpenModalAdd, updateData }) {
  const [inputValue, setInputValue] = useState('');
  const [beneficiary, setBeneficiary] = useState(null);
  const [resultInfo, setResultInfo] = useState(null);
  const [groupName, setGroupName] = useState(null);
  const [showCreate, setShowCreate] = useState(false);
  const navigate = useNavigate();
  async function addToGroup() {
    const response = await addBeneficiary(
      info.group,
      beneficiary.id,
      info.school
    );
    if (response) {
      updateData();
    }
    setOpenModalAdd(false);
  }

  async function searchBeneficiary() {
    setResultInfo(null);
    setShowCreate(false);
    const b = await getBeneficiary(inputValue);
    if (b) {
      setBeneficiary(b);
      if (b.group?.code.indexOf('Grupo') !== -1) {
        setGroupName(b.group?.code);
      } else {
        setGroupName(`Grupo ${b.group?.code}`);
      }
    } else {
      setResultInfo('Beneficiario no existe en el sistema');
      setShowCreate(true);
    }
  }

  function handleInputChange(event) {
    const value = event.target.value;
    if (value) {
      setInputValue(value.toString().trim());
      setResultInfo(null);
      setBeneficiary(null);
    } else {
      setInputValue(value);
    }
  }

  async function createBeneficiary() {
    navigate(
      `/caracterizacion/${inputValue}/school/${info.school}/group/${info.group}`
    );
  }

  return (
    <>
      <section className='modal-info-container'>
        <button onClick={() => setOpenModalAdd(false)} className='button-close'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='20.98'
            height='20.981'
            viewBox='0 0 20.98 20.981'>
            <g id='Icon-close' transform='translate(-308.562 -311.686)'>
              <path
                id='Trazado_679'
                data-name='Trazado 679'
                d='M-4680.317,593.807l16.738,16.738'
                transform='translate(4991 -280)'
                stroke='#bcbcbc'
                strokeLinecap='round'
                strokeWidth='3'
              />
              <path
                id='Trazado_680'
                data-name='Trazado 680'
                d='M-4663.579,593.807l-16.738,16.738'
                transform='translate(4991 -280)'
                fill='none'
                stroke='#bcbcbc'
                strokeLinecap='round'
                strokeWidth='3'
              />
            </g>
          </svg>
        </button>
        <div className='info-container'>
          <h2 className='title'>Agrega un beneficiario</h2>
          <p className='text'>
            Número de documento <span>*</span>
          </p>
          <input
            className='input'
            type='text'
            value={inputValue}
            onChange={handleInputChange}
          />
          {!beneficiary && !showCreate && (
            <div className='button-container'>
              <button
                className='blue-site-button but'
                onClick={searchBeneficiary}>
                BUSCAR
              </button>
            </div>
          )}
          {beneficiary && (
            <div className='beneficiary-info-container'>
              <div className='beneficiary-name'>
                <h3 className='text'>{beneficiary.full_name}</h3>
              </div>
              {beneficiary.group && (
                <div className='beneficiary-group'>
                  <h2>Escuela {beneficiary.school?.code}</h2>
                  <h3>{groupName}</h3>
                </div>
              )}
              {!beneficiary.group && (
                <button
                  type={'button'}
                  onClick={addToGroup}
                  className='blue-site-button search'>
                  AGREGAR AL GRUPO
                </button>
              )}
            </div>
          )}
          {resultInfo && (
            <div className='beneficiary-info-container'>
              <h2>{resultInfo}</h2>
            </div>
          )}
          {showCreate && (
            <button
              type={'button'}
              onClick={createBeneficiary}
              className='blue-site-button search'>
              CREAR
            </button>
          )}
        </div>
      </section>
    </>
  );
}

export default AddBeneficiaryModal;
